<template>
  <pay-on-web-popup
    @close="emitCloseEvent"
  >
    <template #icon>
      <img src="@/assets/pink-flower-drawing.svg" class="popup-icon" alt="" />
    </template>
    <template #title>
      <div class="popup-title">איך לממש את ההטבה שמגיעה לי?</div>
    </template>
    <template #subtitles>

    </template>
    <template #bullets>
      <li>
        להתחבר לרייזאפ דרך הדפדפן שלך (מבלי לעבור לאפליקציה).
      </li>
      <li>
        להיכנס לתפריט הראשי במוצר > הגדרות > הגדרות מינוי. ואז ללחוץ על כפתור "לבחור סוג מינוי".<br>
        <div class="margin-top-m"><b>כאן אפשר לראות את ההטבה שמגיעה לך ולשלם פחות על המינוי.</b></div>
      </li>
      <li>
        סיימת! עכשיו <b>אפשר לחזור לאפליקציה</b> ולהמשיך להיות על זה.
      </li>
    </template>
  </pay-on-web-popup>
</template>

<script>
import Segment from '@/Segment';
import PayOnWebPopup from './PayOnWebPopup.vue';

export default {
  name: 'PayOnWebPromoPopup',
  components: {
    PayOnWebPopup,
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
  created() {
    Segment.trackUserInteraction('ApplePricePopup_WithPromo_Viewed');
  },
};
</script>
